import React, { useEffect } from 'react';
import { useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { getAppRoutes } from './ui/app-routes';
import { sentryLogger } from './lib/shared/sentry-logger';
import config from './config';
import './common.css';

sentryLogger.init(config, {
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes
});

const sentryCreateBrowserRouter = sentryLogger.sentryCreateBrowserRouter(createBrowserRouter);
const router = sentryCreateBrowserRouter(getAppRoutes());

const root = createRoot(document.getElementById('root'));

root.render(<RouterProvider router={router} />);
